import { CardLoader } from 'components/organisms'
import VoucherRuleTableRow from './voucher-rule-table-row'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import { ListPagination } from 'components/organisms'

const propTypes = {
  tableProps      : PropTypes.object,
  voucherRules    : PropTypes.array,
  pagination      : PropTypes.object,
  onPageChange    : PropTypes.func,
  onTableRowClick : PropTypes.func,
  isLoading       : PropTypes.bool
}

/**
 * Table to display ::Customer::Cart::Voucher::Rule data
 * @param {Object} tableProps - additional table props
 * @param {Array<Object>} voucherRules - array of ::Customer::Cart::Voucher::Rule
 * @param {Object} Pagination - pagination object
 * @param {Function} onPageChange - Function that triggered on page change
 * @param {Function} onTableRowClick - Function that triggered on table row click
 */

const VoucherRuleTable = ({
  tableProps,
  voucherRules,
  pagination,
  onPageChange,
  onTableRowClick,
  isLoading
}) => {

  const totalColumns    = 8
  const isVouchersEmpty = voucherRules.length === 0

  const TableContent = () => (
    <Table
      hover
      { ...tableProps }
    >
      <thead>
        <tr>
          <th scope="col">{ 'ID' }</th>
          <th scope="col">{ 'Name' }</th>
          <th scope="col">{ 'Voucher Code' }</th>
          <th scope="col">{ 'Date Start' }</th>
          <th scope="col">{ 'Date Expire' }</th>
          <th scope="col">{ 'Is Active?' }</th>
          <th scope="col">
            { 'Show On' }
            <br />
            { 'Checkout' }
          </th>
          <th scope="col">{ 'Used' }</th>
        </tr>
      </thead>
      <tbody>
        {
          voucherRules.map((voucherRule) => (
            <VoucherRuleTableRow
              key={ `VoucherRuleTableRow-${voucherRule.id}` }
              voucherRule={ voucherRule }
              onRowClick={ onTableRowClick }
            />
          ))
        }
        {
          isVouchersEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'No Voucher found based on your filters.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <ListPagination
        pagination={ pagination }
        onClickPage={ onPageChange }
      />

      <TableContentWithLoader isLoading={ isLoading } />

      <ListPagination
        pagination={ pagination }
        onClickPage={ onPageChange }
      />
    </>
  )
}


VoucherRuleTable.propTypes = propTypes

export default VoucherRuleTable
